module.exports = __webpack_public_path__ + "img/presticom.9e7a6f74.png";